import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { getVegNonVegItemImg } from "src/app/shared/utils/menu-cart-item-functions";

@Component({
  selector: "app-addon-model-repeat",
  templateUrl: "./addon-model-repeat.component.html",
  styleUrls: ["./addon-model-repeat.component.scss"],
})
export class AddonModelRepeatComponent implements OnInit {
  @Input() modalObj;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
  
  getVegNonVegImg(isVeg, containsEgg) {
    return getVegNonVegItemImg(isVeg, containsEgg);
  }
}
